import gql from 'graphql-tag';

const UpdateClaim = gql`
  mutation updateClaim($input: UpdateClaimMutationInput!) {
    updateClaim(input: $input) {
      claim {
        id
        codeClaim
        crmState
        passengerTicketId
        reason
        token
        totalDelay
        courtHearingAt
        nebSentDate
        courtName
        courtAddress
        lawyer {
          id
          name
          surname
        }
        nRg
        courtDecisionDate
        airlineAgreementAmount
        airlineAgreementDate
        paxAgreementAmount
        settlementType
        legalFees
        refundFromLawyerDate
        refundFromLawyerAmountForPax
        refundFromLawyerLegalFeesAmount
        paxTransferDate
        paxToTransferAmount
        conciliationAt
        airlineAmicableAnswer
        airlinePreLitigationAnswer
        overallDelayAtDestination
        legalFormalNotice {
          sentDate
        }
        litigationCountry
        affiliate {
          id
          name
        }
        passengerTicket {
          id
          pnr
          number
          passengerFirstName
          passengerLastName
          passengerPhone
          passengerEmail
          passengerLanguage
          employer
        }
        flightsPassengerTicketsConnection {
          edges {
            cursor
            node {
              id
              status
              flight {
                id
                airlineCode
                airline {
                  name
                  iata
                }
                number
                airportOrigin {
                  name
                  iata
                }
                airportDestination {
                  name
                  iata
                }
                delayedFlightId
                localDepartureDate
                localArrivalDate
              }
            }
          }
        }
        claimsPassengerTicketConnection {
          edges {
            node {
              id
              promoCode {
                id
                code
                percentage
              }
              documentsConnection {
                edges {
                  cursor
                  node {
                    documentId
                    id
                    attachmentContentType
                    documentUrl
                    status
                    conflictsWithClaim
                    document {
                      documentId
                    }
                    type
                  }
                }
              }
              passengerTicket {
                id
                pnr
                number
                passengerFirstName
                passengerLastName
                passengerPhone
                passengerEmail
                passengerLanguage
                employer
                profession
                gender
                nationality
                dateOfBirth
                street
                city
                postCode
                country
                bankInformation
                affiliate {
                  id
                  name
                }
              }
            }
          }
        }
        commentsConnection {
          edges {
            cursor
            node {
              id
              content
            }
          }
        }
      }
    }
  }
`;

export { UpdateClaim };



// WEBPACK FOOTER //
// ./src/mutations/UpdateClaim.js